import { NgOptimizedImage } from '@angular/common';
import { Component, viewChild } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NzAlertComponent } from 'ng-zorro-antd/alert';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzWaveModule } from 'ng-zorro-antd/core/wave';
import { NzDividerComponent } from 'ng-zorro-antd/divider';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { FormsModule } from '@angular/forms';
import { FikoYTKokBilesenComponent } from '../../../../../service/kok-bilesen/kok-bilesen.component';
import { FikoYTKartComponent } from '../../../../../service/fikoyt-ui/src/lib/fikoyt-kart/fikoyt-kart.component';
import { FikoYTDalgaComponent } from '../../../../../service/fikoyt-ui/src/lib/fikoyt-dalga/fikoyt-dalga.component';
import { IstekOlayTuru } from '../../../../../service/fikoyt.istek.service';

@Component({
  selector: 'fikoyt-giris-yap',
  imports: [FormsModule, NgOptimizedImage, FikoYTKartComponent, NzAlertComponent, NzInputModule, NzButtonComponent, NzIconModule, NzTypographyModule, RouterLink, NzWaveModule, NzDividerComponent],
  templateUrl: './giris-yap.component.html',
  standalone: true,
  styleUrl: './giris-yap.component.less'
})
export class GirisYapComponent extends FikoYTKokBilesenComponent {
  readonly rippleComponent = viewChild.required<FikoYTDalgaComponent>('ripple');

  form: any = {
    kullaniciAdi: '',
    parola: '',
  };

  gonder() {
    const formData: FormData = new FormData();


    formData.append('req_body', JSON.stringify(this.form));

    this.FikoYT.istekler.fapisteV1('POST', 'FikoYT.sistem.giris.yap', { vucutParametreler: formData }).subscribe((snc: any) => {
      if (snc.turu == IstekOlayTuru.Cevaplandi) {
        if (snc.sonuc.body.durum.hata == true) {
          let hataMesajlari = "";
          snc.sonuc.body.durum.hatalar.forEach((hata: any) => {
            hataMesajlari += hata.mesaj + "\n";
          });

          this.nzNotification.error("Hatalar Var", hataMesajlari, {
            nzStyle: {
              "white-space": "pre-line",
            }
          });
        } else {
          this.nzNotification.success("Giriş Başarılı", "Sisteme Girişiniz Yapılmıştır");
          /** */
          this.FikoYT.istekler.fapisteV1('POST', 'FikoYT.sistem.aktif-kullanici.bilgi', { vucutParametreler: formData }).subscribe((snc: any) => {
            if (snc.turu == IstekOlayTuru.Cevaplandi) {
              if (snc?.sonuc?.body?.durum?.hata != true) {
                // console.log(snc);
                setTimeout(() => {
                  this.FikoYT.kimlik.aktifKullaniciJson.set(snc?.sonuc?.body?.sonuc);
                  this.FikoYT.parametreler["t"] = Math.random();
                  this.CD.detectChanges();
                }, 0);
              }
            }

          })



          this.router.navigate(["/"]);
        }

      };
    });
  }
}
